import fetch from '../../utils/fetch'

export function getScanConfig(query) {
    return fetch({
        url: '/api/verify/share',
        method: 'GET',
        params: query
    })
}
